import axiosBaseApi from '../common/lib/axiosBaseApi';
import { TotalUserRakeBackPayout, UserRakePayout, UserRakeStats } from './rake.types';

export const getRakeStats = async () => await axiosBaseApi.get<UserRakeStats>(`/v1/rake/stats`);

export const getRakePayouts = async () => await axiosBaseApi.get<UserRakePayout[]>(`/v1/rake/rake-share`);

export const getTotalUnpaidRakeback = async () =>
  await axiosBaseApi.get<TotalUserRakeBackPayout>(`/v1/rake/unpaid-rake-back-total`);
